export default __webpack_public_path__ + "static/partners-bg-f7496dcf4290014017beccca56102cf0.png";